import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../../shared/notification/useNotification';
import { BehApiRoutes, behClient } from '../beh-api';

export const CHECK_DESTINATION_SIGNING_KEY_PAIR_TASK_CODE_PREFIX =
  'fitconnect:checkDestinationSigningKeyPair';
export const CHECK_DESTINATION_ENCRYPTION_KEY_PAIR_TASK_CODE_PREFIX =
  'fitconnect:checkDestinationEncryptionKeyPair';

export interface AdminTaskSpecificInfo {
  destinationId: string;
}

export interface AdminTask {
  id: number;
  taskType: string;
  createdAt: string;
  taskSpecificInfo: AdminTaskSpecificInfo | null;
}

export function useAdminTasks() {
  const { notifyUserFromRequest } = useNotification();
  const { t } = useTranslation();

  return useQuery({
    queryKey: [BehApiRoutes.adminTasks()],
    queryFn: () =>
      notifyUserFromRequest<Array<AdminTask>, unknown>(
        () => behClient.get(BehApiRoutes.adminTasks()),
        { errorMessage: t('api.error.adminTasks') }
      )
  });
}

export function useDeleteAdminTask() {
  const { notifyUserFromRequest } = useNotification();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (taskId: number) =>
      notifyUserFromRequest<void, unknown>(
        () => behClient.delete(`${BehApiRoutes.adminTasks()}/${taskId}`),
        { errorMessage: t('api.error.adminTasks') }
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BehApiRoutes.adminTasks()] });
    }
  });
}
